/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import EventEmitter from 'eventemitter3';

/**
 * @import { StatusInfoDialogOpenStrategyEventTypes, StatusInfoDialogOpenStrategy, Shortcut } from '..'
 */

// Teoreticky môže fungovať na WebOS/Samsungu. Problémy:
// - použitie keyCode (derepecated, ale v kóde je stále používaný). Ak by to náhodou fungoval cez
//   natívny keydown bez akéhokoľvek mapovania, mohlo by sa jednať o náhodu. Pre to by bolo nutné aj:
//   1. Rozšíriť ControlListener/ControlParser/ControlButton (v Controlbutton je naznačené TODO o vytvorenie ControlSource.
//      V tomto prípade nie je ControlSource potrebný, skôr ide zachovanie informácií
//      z KeybaordEventu potrebné pre tento use-case: ctrlKey, altKey).
//   2. Pridať ControlListener ako závislosť pre jednotnosť mapovania F1.
// - (odpozorované webOS) špecifické správanie pri kombinácii CTRL + ALT + F*, pri držaní
//   CTRL + ALT a následnom stlačení akéhokoľvek F* sa detekuje kláves ESCAPE.
/**
 * Třída pro strategii otevření dialogu na základě stisku klávesové zkratky.
 * Tato implementace naslouchá události `keydown` v dokumentu a
 * vyvolá otevření dialogu, pokud je stisknuta specifikovaná zkratka.
 * @implements {StatusInfoDialogOpenStrategy}
 */
export default class StatusInfoDialogOpenStrategyShortcut {
  /**
   * @param {Object} opts
   * @param {Shortcut} [opts.shortcut]
   */
  constructor({
    shortcut = { keyCode: 112, modifiers: ['ctrlKey', 'shiftKey'] }
  } = {}) {
    /** @type {EventEmitter<StatusInfoDialogOpenStrategyEventTypes>} */
    this.emitter = new EventEmitter();
    this.shortcut = shortcut;
    this.onButtonDown = this.onButtonDown.bind(this);
    document.addEventListener('keydown', this.onButtonDown);
  }

  /** @type {StatusInfoDialogOpenStrategy['destroy']} */
  destroy() {
    document.removeEventListener('keydown', this.onButtonDown);
  }

  /** @type {StatusInfoDialogOpenStrategy['off']} */
  off(...args) {
    this.emitter.off(...args);
  }

  /** @type {StatusInfoDialogOpenStrategy['on']} */
  on(...args) {
    this.emitter.on(...args);
  }

  /**
   * @private
   * @param {KeyboardEvent} event
   */
  onButtonDown(event) {
    const { keyCode, modifiers } = this.shortcut;
    if (
      event.keyCode === keyCode &&
      modifiers.every((modifier) => event[modifier])
    ) {
      this.emitter.emit('open');
    }
  }
}
